<template>
  <div class="equities-ioi">
    <page-header header="Equities IOIs">
      <router-link
        :to="{ name: 'equities.create' }"
        class="btn btn-primary"
      >
        Create new IOI
      </router-link>
    </page-header>

    <div class="equities-ioi__table">
      <div class="mt-4 d-flex align-items-center equities-ioi__search">
        <search
          class="mr-3"
          v-model="search"
          @input="filterIois"
        />

        <div class="d-flex flex-1">
          <button class="btn btn-outline-secondary btn-ioi-expired">
            Mark expired
          </button>
        </div>
      </div>
      <ioi-table
        class="mt-3"
        :data="filteredIoiData"
      />
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
import IoiTable from './IOITable'

export default {
  components: {
    Search,
    IoiTable,
  },

  data () {
    return {
      search: '',
      ioiData: [],
      filteredIoiData: [],
    }
  },

  async activated () {
    try {
      const {id: userId} = this.$login.getUser()
      const {data} = await this.$http.get('/iois/iois/unexpired', {headers: {userId}})
      this.ioiData = data
      this.filteredIoiData = data
    } catch (error) {
      console.error(error)
    }
  },

  methods: {
    filterIois (input = '') {
      const lowercase = (s) => `${s}`.toLowerCase()
      this.filteredIoiData = this.ioiData.filter(({securityNameBBG}) => lowercase(securityNameBBG).includes(lowercase(input)))
    },
  },
}
</script>


<style lang="scss">
.equities-ioi {
  &__table {
  }

  .btn-ioi-expired {
    width: 8rem;
  }

  .btn-ioi-edit {
    width: 4rem;
  }
}
</style>

